const options = {
  width: "w",
  height: "h",
  backgroundColor: "bg",
  fit: "fit",
  format: "fm",
  quality: "q"
};
const shouldSkipImageProcessing = (url) => url.toLowerCase().endsWith(".gif");
const createImageUrl = (url, params = {}) => {
  if (shouldSkipImageProcessing(url)) {
    return url;
  }
  const { aspectRatio, ...cleanParams } = params;
  if (cleanParams.height === void 0 && aspectRatio && cleanParams.width) {
    cleanParams.height = Math.round(cleanParams.width / aspectRatio);
  }
  if (cleanParams.width && cleanParams.width > 1920 && (!cleanParams.quality || cleanParams.quality > 50)) {
    cleanParams.quality = 50;
  }
  const urlParams = Object.entries(cleanParams).map(([key, value]) => {
    return `${options[key]}=${value}`;
  });
  return `${url}?${urlParams.join("&")}&auto=format`;
};
export {
  createImageUrl,
  shouldSkipImageProcessing
};
//# sourceMappingURL=create-image-url.js.map
